/* Copyright 2019 Ellucian Company L.P. and its affiliates.
 * File: SpecifcErrorView.tsx
 * Type: Container component */

// #region Imports
import React from 'react';
import ReactDOM from 'react-dom';

// Core components
import SpecificError from '@hedtech/powercampus-design-system/react/components/Errors/SpecificError';

// RenderDOM: Component
ReactDOM.render(<SpecificError />, document.getElementById('root'));